import { AllRows, Columns, ReportData } from '../result.interface';


export function getFileExportMonitoreoCantidadEventosUnidad(ctx: any, vrs: number): any {
       
   
   var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[] = [];


    var placa_cell_px_width = 80; //en px
    var codigo_cell_px_width = 80; //en px
    var date_cell_px_width = 100; //en px
    var hour_cell_px_width = 100; //en px
    var total_cell_ch_width = 80;

    //var nom_inf = "REPORTE DE ENTRADA Y SALIDA";

    var allRows: AllRows[] = [
        {
          cells: [
            { value: ctx.repTitle, ...ctx.headerCellConfig, colSpan: 3 }
          ],
          height: ctx.headerRowsHeight,
        },
        ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
    ];

    var table_width = ctx.sortedData[0][1][0].length;// 1 + (ctx.chkDateHour? 4:2) + 4;
    //var vehiculo_width = (ctx.chkDateHour? 4:3);

    ctx.sortedData.forEach((table_data: any) => {
      if(table_data[1].length > 0){
        column_config = [];

        bol_datos_ex = true;

        var nom_vehi = table_data[0][1];

        /* Table Header */
        var rows: AllRows[] = [
          {
            cells: [
              { value: ctx.repTitle, ...ctx.headerCellConfig, colSpan: table_width }
            ],
            height: ctx.headerRowsHeight,
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
          {
            cells: [
              { value: table_data[0].name, ...ctx.colHeaderConfig, fontSize: 12, colSpan: table_width },
              // { value: table_data[0].slug, ...ctx.colHeaderConfig , colSpan: table_width - vehiculo_width },
            ],
            height: ctx.colsHeaderHeight
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight)

        ];

        // var rows: AllRows[] = [
        //   {
        //     cells: [
        //       { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
        //     ],
        //     height: ctx.headerRowsHeight,
        //   },
        //   ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
        //   {
        //     cells: [
        //       { value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
        //       { value: "PERIODO",  ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
        //     ],
        //     height: ctx.subHeaderHeight
        //   },
        //   {
        //     cells: [
        //       { value: table_data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
        //       { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
        //     ],
        //     height: ctx.subHeaderContentHeight
        //   },
        //   ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
        // ];
















        /* Table Body */

        var cellsCampos = [];

        //----------- CABECERA ------------
        for (let i = 0; i < table_data[1][0].length; i++) {
            const element = table_data[1][0][i];
            cellsCampos.push({ value: element, ...ctx.colHeaderConfig });
        }
    
        rows.push({
          cells: cellsCampos,
          height: ctx.colsHeaderHeight
        });

        //----------- CONTENIDO / FILAS ------------
        table_data[1].forEach((item: any, index: number) => {
            if ( index > 0 ) {
                var cellsCuerpo = [];
                for (let j = 0; j < item.length; j++) {
                    const element = item[j];
                    cellsCuerpo.push({ value: element, ...ctx.bodyRowsConfig });
                }
                rows.push({
                    cells:cellsCuerpo,
                    height: ctx.bodyRowsHeight,
                });
            }
        });

        // //********************************************* excel version 2 *********************************
        if ( vrs == 2 ) {
          rows.splice(0, ctx.headerRowSpan);
          rows.push(...ctx.spaceBetweenTables);
          allRows = allRows.concat(rows);
        }

        // //********************************************* excel version 1 *********************************

        /* Ancho de Columnas */

        if( vrs == 1 ){
          column_config = [
            { width: ctx.w_item },
          ];
          if(ctx.chkDateHour){
            column_config.push(
              { width: date_cell_px_width },
              { width: hour_cell_px_width },
              { width: date_cell_px_width },
              { width: hour_cell_px_width },
            )
          } else {
            column_config.push(
              { width: ctx.w_date_and_hour },
              { width: ctx.w_date_and_hour },
            )
          }
          column_config.push(
            // { width: ctx.calculateColWidth(duracion_cell_ch_width) },
            // { width: ctx.calculateColWidth(zone_name_cell_ch_width) },
            // { width: ctx.calculateColWidth(zone_position_cell_ch_width) },
            // { width: ctx.calculateColWidth(pc_cell_ch_width) },
          );

          /* Fin Ancho de Columnas */

          exportFileEx.push({
            freezePane: {
                rowSplit: 3 //ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: table_data[0].name, // nom_vehi,
            rows: rows
          });

        //   duracion_cell_ch_width = "Duracion".length;
        //   zone_name_cell_ch_width = "Nombre de Zona".length;
        //   zone_position_cell_ch_width = "Posicion de Zona".length;
        //   pc_cell_ch_width = "Punto cercano".length;

        }

      } // if si hay datos del vehiculo
    });

    //NOTA: width * 1.28 (aprox) = Ancho de columna en excel

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: ctx.w_item },
      ];
      if(ctx.chkDateHour){
        column_config.push(
          { width: date_cell_px_width },
          { width: hour_cell_px_width },
          { width: date_cell_px_width },
          { width: hour_cell_px_width },
        )
      } else {
        column_config.push(
          { width: ctx.w_date_and_hour },
          { width: ctx.w_date_and_hour },
        )
      }
      column_config.push(
        // { width: ctx.calculateColWidth(duracion_cell_ch_width) },
        // { width: ctx.calculateColWidth(zone_name_cell_ch_width) },
        // { width: ctx.calculateColWidth(zone_position_cell_ch_width) },
        // { width: ctx.calculateColWidth(pc_cell_ch_width) },
      );

      exportFileEx.push({
        freezePane: {
            rowSplit: 3, //ctx.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });

    }


    console.log("===>exportFileEx getFileExportMonitoreoCantidadEventosUnidad", exportFileEx);  
        
    if (bol_datos_ex) {
        return exportFileEx;
    } else {
        return [];
    }

}
